/** Marketing book-a-demo page used by "Talk to Notch" CTAs (NS-364). */
export const BOOK_A_DEMO_URL = 'https://www.notch.so/book-a-demo'
